import { render } from "./InvoiceDocument.vue?vue&type=template&id=40a91c7c"
import script from "./InvoiceDocument.vue?vue&type=script&lang=js"
export * from "./InvoiceDocument.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__